import { useState } from 'react';
import { Space, Cascader } from 'antd';
import styles from '../../index.module.less';
import selfStyles from './index.module.less';
import { LayoutEnum } from '../../enum';

const Index = (props: any) => {
  const { field, onChange, value } = props
  const { width, label, placeholder, options, layout, fieldNames, changeOnSelect } = field

  const [inputValue, setInputValue] = useState('')

  const triggerChange = v => {
    onChange?.(v)
  }
  const handleInputValueChange = v => {
    setInputValue(v)
    triggerChange(v)
  }

  return (
    <div className={styles.innerFieldWrap}>
      {layout === LayoutEnum.HORIZONTAL ? (
        <Space.Compact block>
          <div className={styles.addon}>{label}</div>
          <Cascader
            className={selfStyles['custom-cascader']}
            showSearch
            changeOnSelect={changeOnSelect}
            placeholder={placeholder || `请选择${label}`}
            options={options}
            fieldNames={fieldNames}
            value={value || inputValue}
            style={{ width }}
            onChange={handleInputValueChange}
          />
        </Space.Compact>
      ) : (
        <div className={styles.vertical}>
          <div className={styles.addon}>{label}</div>
          <Cascader
            className={selfStyles['custom-cascader']}
            showSearch
            changeOnSelect={changeOnSelect}
            placeholder={placeholder || `请选择${label}`}
            fieldNames={fieldNames}
            options={options}
            value={value || inputValue}
            style={{ width }}
            onChange={handleInputValueChange}
          />
        </div>
      )}
    </div>
  )
}

export default Index
